import template from './housing-type.jade';
import housingType from './../../../enums/housing-type';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

// отвечает за флаг isApartments
export default angular.module('cian.addForm.housingType', []).directive('cianAfAboutObjectHousingType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService, store) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = housingType;

    this.validation = validation(this.form, 'housingType', {
      required: 'Выберите тип жилья',
    });

    this.handleChange = () => {
      const state = store.getState();
      const category = selectAnalyticsOfferStatus(state);

      trackRequiredFieldFill(category, 'type_of_housing');
    };
  },
  controllerAs: 'housingType',
  template,
})).name;
